import { lang } from "../config/app.config";
import { httpbase } from "../utils/axios.utils";


export const fetchItSubsystem = async()=>{
  try{
    const response = await httpbase().get('/resources/it-subsystem/?lang='+lang);
    return response.data.data;
  }catch(e){
    console.log(e);
    return
  }
}